export default __webpack_public_path__ + "static/media/cute_plant.581d51d8.png";